import { gql } from "@apollo/client";

export const LINK_HASHTAG_TO_FEED = gql`
  mutation linkHashtagsToFeed($linkHashtagsToFeedInput: LinkHashtagsToFeedInput!) {
    linkHashtagsToFeed(linkHashtagsToFeedInput: $linkHashtagsToFeedInput) {
      id
    }
  }
`;
